import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import "./Service3.css";

// Images of locations
import forestImg from "../images/forest.jpg";
import lakeImg from "../images/lake.jpg";
import sanctuaryImg from "../images/sanctuary.jpeg";

function Service3() {
  const navigate = useNavigate();

  // Locations data
  const locations = [
    {
      id: 1,
      name: "Rainforest Reserve",
      description: "Capture exotic birds in a lush green rainforest environment.",
      image: forestImg,
      price: 120,
    },
    {
      id: 2,
      name: "Crystal Lake",
      description: "Perfect spot for flamingos and swans surrounded by crystal water.",
      image: lakeImg,
      price: 90,
    },
    {
      id: 3,
      name: "Wildlife Sanctuary",
      description: "Home to eagles, peacocks, and many rare bird species.",
      image: sanctuaryImg,
      price: 150,
    },
  ];

  const [selectedLocation, setSelectedLocation] = useState(null);
  const [formData, setFormData] = useState({ name: "", email: "" });

  // Comments state
  const [comments, setComments] = useState([]);
  const [commentMessage, setCommentMessage] = useState("");

  // Fetch comments from MongoDB
  useEffect(() => {
    fetch("http://localhost:5000/api/service3/comments")
      .then((res) => res.json())
      .then((data) => setComments(Array.isArray(data) ? data : []))
      .catch((err) => console.error(err));
  }, []);

  // Handle selecting a location
  const handleSelect = (loc) => setSelectedLocation(loc);

  // Handle booking submission
  const handleBooking = async () => {
    if (!selectedLocation) return alert("Select a location first!");
    if (!formData.name || !formData.email) return alert("Enter your name and email!");

    try {
      const res = await fetch("http://localhost:5000/api/service3/book", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          name: formData.name,
          email: formData.email,
          location: selectedLocation.name,
          price: selectedLocation.price,
        }),
      });
      const data = await res.json();
      alert("Booking successful!");
      setFormData({ name: "", email: "" });
      setSelectedLocation(null);
    } catch (err) {
      console.error(err);
    }
  };

  // Handle posting comment
  const handleComment = async (e) => {
    e.preventDefault();
    if (!formData.name || !commentMessage) return alert("Enter your name and comment!");

    try {
      const res = await fetch("http://localhost:5000/api/service3/comment", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ name: formData.name, email: formData.email, message: commentMessage }),
      });
      const newComment = await res.json();
      setComments([newComment, ...(Array.isArray(comments) ? comments : [])]);
      setCommentMessage("");
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <div className="service3-page">
    

      {/* Hero Section */}
      <section className="service3-hero">
        <h1>Bird Photography Booking</h1>
        <p>Choose your dream photography location and book a professional bird photo session with our expert photographers.</p>
      </section>

      {/* Locations */}
      <section className="service3-locations">
        <h2>Available Photography Locations</h2>
        <div className="location-grid">
          {locations.length > 0 &&
            locations.map((loc) => (
              <div
                key={loc.id}
                className={`location-card ${selectedLocation?.id === loc.id ? "selected" : ""}`}
                onClick={() => handleSelect(loc)}
              >
                <img src={loc.image} alt={loc.name} />
                <h3>{loc.name}</h3>
                <p>{loc.description}</p>
                <p className="price">Price: ${loc.price}</p>
              </div>
            ))}
        </div>

        {/* Inline Booking Form */}
        <div className="booking-section-inline">
          <input
            type="text"
            placeholder="Your Name"
            value={formData.name}
            onChange={(e) => setFormData({ ...formData, name: e.target.value })}
          />
          <input
            type="email"
            placeholder="Your Email"
            value={formData.email}
            onChange={(e) => setFormData({ ...formData, email: e.target.value })}
          />
          <button onClick={handleBooking}>Book & Pay</button>
        </div>
      </section>

      {/* Comments Section */}
      <section className="comments-section">
        <h2>Community Comments</h2>

        <form onSubmit={handleComment} className="comment-form">
          <textarea
            placeholder="Write your comment..."
            value={commentMessage}
            onChange={(e) => setCommentMessage(e.target.value)}
          />
          <button type="submit">Post Comment</button>
        </form>

        <div className="comment-list">
          {comments && comments.length > 0 ? (
            comments.map((c) => (
              <div key={c._id || c.id} className="comment">
                <strong>{c.name}</strong> ({new Date(c.date).toLocaleString()}):
                <p>{c.message}</p>
              </div>
            ))
          ) : (
            <p>No comments yet.</p>
          )}
        </div>
      </section>

    
    </div>
  );
}

export default Service3;
